<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="产品列表" style="height:auto" >
      <el-form :inline="true" :model="productForm" class="demo-form-inline">
        <el-form-item label="产品型号">
          <el-input v-model.trim="productForm.manufacturerNumber" size="mini" placeholder="产品型号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="onQuerySubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-top:-56px; float:right; margin-right:20px;">
        <el-upload
          class="upload-demo"
          :action="serverUrl"
          :show-file-list="false"
          list-type="text"
          :headers="myHeaders"
          :before-upload="beforeUpload"
          :on-success="uploadSuccMethod"
          :on-error="uploadFail">
          <el-button type="primary" size="small" icon="el-icon-circle-plus-outline">上传物料型号</el-button>
        </el-upload>
      </div>
      <el-table
        :data="data"
        size = "small"
        border>
        <el-table-column
          fixed
          prop="id"
          label="ID编号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="categoryName"
          show-overflow-tooltip
          label="类别名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="brandEnName"
          label="品牌名称"
          show-overflow-tooltip
          width="150">
        </el-table-column>
        <el-table-column
          prop="manufacturerNumber"
          show-overflow-tooltip
          label="产品型号"
          width="160">
        </el-table-column>
        <el-table-column
          prop="stockState"
          width="90"
          :formatter="formatSource"
          label="价格来源">
        </el-table-column>
        <el-table-column
          prop="platFormId"
          show-overflow-tooltip
          width="150"
          :formatter="formatPlatForm"
          label="产品来源">
        </el-table-column>
        <el-table-column
          prop="stockCount"
          width="90"
          label="库存数量">
        </el-table-column>
        <el-table-column
          prop="segmentPrice"
          show-overflow-tooltip
          label="批量价格">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="160">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
    <el-dialog title="编辑产品" :visible.sync="dialogFormVisible" width="600px">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="产品型号">
            <el-input v-model.trim="form.manufacturerNumber" disabled></el-input>
        </el-form-item>
        <el-form-item label="产品库存">
            <el-input v-model.trim="form.stockCount" placeholder="产品库存"></el-input>
        </el-form-item>
        <el-form-item label="产品价格" >
              <div style="height:40px;line-height:40px;cursor: pointer;"  @click="addPriceClick">
                <i class="el-icon-circle-plus" style="font-size:18px;margin-right:5px"></i>添加价格
              </div>
            <div v-for="(item,index) in this.form.segmentPriceList" :key="index" style="margin-top:10px">
                <el-input v-model.trim="item.count" style="width:80px;"></el-input>
                <el-input v-model.trim="item.price" style="width:220px;"></el-input>
                <el-button type="danger" @click="deletePriceClick(index)">删除</el-button>
            </div>
          
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSubmit">立即编辑</el-button>
            <el-button @click="onCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      serverUrl: "https://admin.ruidan.com/api/upload/product/load", // 这里写你要上传的图片服务器地址
      // serverUrl: "http://127.0.0.1:7006/upload/product/load",
      myHeaders: {Authorization: this.user.getToken()},
      productForm: {
        manufacturerNumber: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      dialogFormVisible:false, 
      display: false,
      form: {
        id: '',
        platformId: '',
        productNumber: '',
        manufacturerNumber: '',
        stockCount: '',
        segmentPrice: '',
        segmentPriceList: [],
        token: this.user.getToken()
      },
      segmentPriceList: []
    };
  },
  components: {
    pagination
  },
  methods: {
    formatSource: function(row, column, cellValue) {
      if (cellValue === 0) {
        return "digikey";
      } else if (cellValue === 10) {
        return "京北通宇";
      } else if (cellValue === 8) {
        return "国内现货";
      } else if (cellValue === 4) {
        return "云汉商城";
      } else if (cellValue === 5) {
        return "华强商城";
      } else if (cellValue === 6) {
        return "维样商城";
      } else if(cellValue === 2) {
        return "自营库存";
      } else if(cellValue === -1) {
        return "mouser";
      } else if(cellValue === -2) {
        return "arrow";
      } else if(cellValue === 11) {
        return "圣禾堂";
      } else if(cellValue === 3) {
        return "立创商城";
      } else if(cellValue === 7) {
        return "华秋";
      } else if(cellValue === 9) {
        return "油柑网";
      }  else if(cellValue === -3) {
        return "TTI";
      } else if(cellValue === -4) {
        return "Verical";
      } else if(cellValue === -5) {
        return "elementas";
      } else if(cellValue === -6) {
        return "avnetUs";
      } else if(cellValue === -7) {
        return "chip1stop";
      } else if(cellValue === -8) {
        return "future";
      } else if(cellValue === -9) {
        return "element14_uk";
      } else if(cellValue === -10) {
        return "onlinecomponents";
      } else if(cellValue === -11) {
        return "rscomponents";
      }else{
        return "其他";
      }
    },
    formatPlatForm: function(row, column, cellValue) {
      if (cellValue === 10) {
        return "自营现货";
      } else if (cellValue === 15) {
        return "国内现货";
      } else if (cellValue === 20) {
        return "DIGIKEY";
      } else if (cellValue === 30 ) {
        return "MOUSER";
      } else{
        return cellValue;
      }
    },
    uploadSuccMethod: function(res) {
      this.$message({
          message: '产品上传数据成功！',
          type: 'success'
        });
      this.getProductData()
    },
    beforeUpload(file) {
      //判断文件格式
      console.log(file.name)
      let hz = file.name.split(".")[1]
      if (hz != 'xlsx' && hz != 'xls') {
        return false;
      }
    },
    uploadFail: function() {
      this.$message.error("上传产品失败，请联系管理员!");
    },
    getProductData: function() {
      this.optionItem = this.common.extend(this.productForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/product/list',
        this.optionItem, res => 
        {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    handleEdit: function(row) {
      // this.$router.push({name:'productEditor',params:row})
      this.dialogFormVisible = true
      this.form.platformId = row.platFormId
      this.form.productNumber = row.productNumber
      this.form.manufacturerNumber = row.manufacturerNumber
      this.form.stockCount = row.stockCount
      this.form.segmentPriceList = eval('(' + row.segmentPrice + ')')
      this.form.id =  row.id
      this.form.segmentPrice = row.segmentPrice
    },
    addPriceClick(){
        if (this.form.segmentPriceList == null) {
          this.form.segmentPriceList = []
        }
        this.form.segmentPriceList.push({price:'',count:''})
    },
    deletePriceClick(index){
        this.$confirm('此操作删除价格'+this.form.segmentPriceList[index].price+', 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
              this.form.segmentPriceList.splice(index,1)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
    },
    onQuerySubmit: function() {
      this.getProductData()
    },
    onSubmit() {
      // 初始化默认加载菜单
      console.log(JSON.stringify(this.form))
      //校验输入的数据
      let validateRes = false
      let isIntNumber= /(^[1-9]\d*$)/
      let isDoubleNumber= /\d+(\.\d+)?/
      for(let i=0; i<this.form.segmentPriceList.length;i++){
          if(!isIntNumber.test(this.form.segmentPriceList[i].count)||!isDoubleNumber.test(this.form.segmentPriceList[i].price)){
            this.$message({
              type: 'info',
              message: '请填入正确的参数'
            })
            validateRes = false
            break;
          } else {
            validateRes = true
          }
        }
        this.form.segmentPrice = JSON.stringify(this.form.segmentPriceList)
      if(validateRes){
        this.http.post(
          '/product/editor', 
          this.form, res => {
            if (res.success) {
              this.dialogFormVisible = false
              // 返回正确的处理
              this.getProductData()
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      }
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getProductData()
    },
    onCancel() {
        this.dialogFormVisible = false
    }
  },
  mounted: function() {
    this.getProductData();
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-input--suffix .el-input__inner {
  padding-right: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/product/productList.vue